import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import {UtilsService} from '../../../core/services/utils.service';
import { Product } from '../../models/product';

@Component({
  selector: 'app-move-bid-dialog',
  templateUrl: './move-bid-dialog.component.html',
  styleUrls: ['./move-bid-dialog.component.css']
})
export class MoveBidDialogComponent implements OnInit {

  radioGroupName: string = "productMoveToList";
  selectedProduct: Product = null;

  @Output() buttonEvent = new EventEmitter<Product>();

  constructor(private utilsService: UtilsService) { }

  ngOnInit() {
  }

  receiveSelectedProductChangedEvent(event: Product) {
    this.selectedProduct = event;
    this.utilsService.debugLog(this.selectedProduct);
  }

  moveClicked() {
    const returnVal = this.selectedProduct;
    this.buttonEvent.emit(returnVal);
  }

  cancelClicked() {
    this.buttonEvent.emit(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/move-bid-dialog/move-bid-dialog.component.ts